import Modal from "@material-ui/core/Modal";
import { DialogContentText, makeStyles } from "@material-ui/core";
import React from "react";
import Link from "@material-ui/core/Link"
import LaunchIcon from "@material-ui/icons/Launch"
import CustomModal from "./custom-modal";


export default function TermsModal(props) {
    const useStyles = makeStyles((theme) => ({
        confirmationBtn: {
            backgroundColor: '#b9251c',
            color: '#fff',
            border: '#b9251c'
        },
        '.MuiButton-contained:hover': {
            backgroundColor: '#b9251c !important',
        },
        linkContainer: {
            padding: theme.spacing(2),
          },
          pdfSection: {
            display: "flex",
            justifyContent: "center",
          },
          link: {
            textDecoration: 'underline'
          },
          iframe: {
            border: '2px solid red;"'
          },
          additionalTerms: {
            marginTop:'10px',
            paddingBottom:'10px',
            fontWeight:'bold'
          }
      }));

    const classes = useStyles();

    return (
              <CustomModal
                submitText="I Acknowledge"
                size="medium"
                title="Terms of Use"
                showCloseIcon
                showModal={props.open}
                onClose={() => props.onClose()}
                onSubmit={()=>{
                  props.onAccepted()
                }}
                onCloseModal={()=>window.open('https://review-tool.dev.blockchain.ey.com')}                
            >
                <DialogContentText color="textPrimary">You are entering the EY's Smart Contract Review Tool.Please review the Terms Of Use attached below,then click on the acknowledgement button below.By doing so,you also acknowledge the Additional Terms associated with use of this version.</DialogContentText>
              <Link className={classes.link} href="./terms.pdf" target="_blank">
                Terms of Use (PDF version)
              </Link>
              <LaunchIcon fontSize="small" />
              <iframe
                title="terms"
                src="./terms.pdf#toolbar=0&view=FitH"
                height="50%"
                width="100%"
              />
            <DialogContentText className={classes.additionalTerms}>Additional Terms</DialogContentText>
            <DialogContentText color="textPrimary">As an amendment to Section 1.3 of the Terms Of Use, this version is available for your personal and private use.Use on behalf of an Organization is expressly prohibited.</DialogContentText>
            </CustomModal>
    )

}